import { TRoomsParams } from 'common/types/floor-params.type';
import { ProjectConfigurationParametersEnum, TSearchConfigurationsResponse } from '../types';

export const parseSearchConfigurationsResponse = (
  response: TSearchConfigurationsResponse,
  calculatorId?: string
) => {
  const rooms: TRoomsParams[] = [];
  response.content.forEach(item => {
    item.configurations.forEach(configuration => {
      let square;
      let typeInstallation;
      let length;
      let width;
      let roomType;
      configuration.projectConfigurationParameters.forEach(parameter => {
        switch (parameter.key) {
          case ProjectConfigurationParametersEnum.width:
            width = parameter.value;
            break;
          case ProjectConfigurationParametersEnum.length:
            length = parameter.value;
            break;
          case ProjectConfigurationParametersEnum.layingType:
            typeInstallation = parameter.value;
            break;
          case ProjectConfigurationParametersEnum.area:
            square = parameter.value;
            break;
          case ProjectConfigurationParametersEnum.roomType:
            roomType = parameter.value;
            break;
          default:
            break;
        }
      });
      rooms.push({
        id: configuration.id,
        createdDate: configuration.createdDate,
        square: square ? Number(square) : undefined,
        width: width ? Number(width) : undefined,
        length: length ? Number(length) : undefined,
        typeInstallation,
        isAuthorized: item.isAuthorized,
        roomType,
        ...(calculatorId ? { calculatorId } : {}),
      });
    });
  });

  return rooms;
};
